<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <span style="font-size: 30px">Escalas</span>
        <v-row>
          <v-col cols="12" lg="6" md="6">
            <v-select
              v-model="form.department"
              label="Departamento"
              :items="departments"
              item-value="id"
              item-text="department"
              readonly
              outlined
              denseoutlined
              dense
            ></v-select>
          </v-col>
          <v-col cols="12" lg="3" md="3">
            <v-select
              v-model="form.year"
              label="Ano"
              :items="years_list"
              outlined
              dense
              @change="existsScale() || changeYear()"
            ></v-select>
          </v-col>
          <v-col cols="12" lg="3" md="3">
            <v-select
              v-model="form.month"
              label="Mês"
              :items="months_of_the_year"
              item-value="id"
              item-text="name"
              outlined
              dense
              @change="existsScale"
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="12" class="d-flex" style="box-sizing: border-box">
        <v-card class="flex-grow-1">
          <v-app-bar dark dense color="red lighten-1" class="justify-center d-flex">
            <v-toolbar-title class="text-md-h4 text-sm-h5 justify-center align-center d-flex">
              <v-btn icon large @click="prev">
                <v-icon large>mdi-chevron-left</v-icon>
              </v-btn>
              {{ form.month_name }} - {{ form.year }}
              <v-btn icon large @click="next">
                <v-icon large>mdi-chevron-right</v-icon>
              </v-btn>
            </v-toolbar-title>
          </v-app-bar>
          <v-container class="ma-0 pa-0" fluid>
            <v-container
              v-if="!scale_exists"
              fluid
              fill-height
              class="justify-center flex-column"
              style="
                background: rgba(20, 20, 20, 0.6);
                position: absolute;
                z-index: 4;
                border-radius: 4px;
              "
            >
              <span class="text-lg-h3 text-h4 white--text mb-2"
                >Não existe escala neste mês, crie para iniciar</span
              >
              <v-btn color="green lighten-1" class="white--text" large @click="scaleCreate">
                Criar Escala
              </v-btn>
            </v-container>
            <v-container
              v-if="scale_exists && scale.status == 3"
              fluid
              fill-height
              class="justify-center flex-column"
              style="
                background: rgba(20, 20, 20, 0.6);
                position: absolute;
                z-index: 4;
                border-radius: 4px;
              "
            >
              <span class="text-lg-h3 text-h4 white--text mb-2">Escala Finalizada.</span>
              <p class="text-lg-h3 text-h4 white--text mb-2 text-center">
                Você pode cancelar esta escala para criar uma nova clicando no botão abaixo.
              </p>
              <v-container class="d-flex flex-column" style="width: 300px">
                <v-btn color="blue lighten-1" class="white--text mb-4" large @click="editScale">
                  Editar Escala
                </v-btn>
                <v-btn color="red lighten-1" class="white--text" large @click="cancelScale">
                  Cancelar Escala
                </v-btn>
              </v-container>
            </v-container>
            <v-calendar
              ref="calendar"
              v-model="calendar_focus"
              class="mt-2"
              :type="calendar_type"
              :events="events"
              :event-color="getEventColor"
              @change="getGeneralEvents"
              @click:more="viewDay"
              @click:date="dismiss"
            >
            </v-calendar>
          </v-container>
          <v-divider class="ma-4"></v-divider>
          <v-row>
            <v-col cols="12" lg="6">
              <v-row class="d-flex justify-end px-4">
                <!-- Seleção de funcionário -->
                <v-btn
                  v-if="scale_exists"
                  class="mr-auto ml-4 white--text"
                  color="red lighten-1"
                  @click="cancelScale"
                >
                  Cancelar Escala
                </v-btn>
                <v-dialog v-model="add_employee_dialog" max-width="800">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" color="green" dark medium v-on="on">
                      Adicionar Funcionário
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title> Adicionar Funcionário </v-card-title>
                    <v-card-text>
                      <v-list max-height="500" class="overflow-y-auto">
                        <v-list-item
                          v-for="employee in employee_list"
                          :key="employee.id"
                          class="mb-2"
                        >
                          <v-list-item-avatar>
                            <img :src="image_host + employee.profile_image" />
                          </v-list-item-avatar>
                          <v-list-item-content>
                            {{ employee.full_name }}
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              color="green"
                              class="white--text"
                              @click="createEmployeeScale(employee)"
                            >
                              <!-- <v-icon color="white">mdi-plus</v-icon> -->
                              Escalar
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-dialog>
                <!-- ESCALA -->
                <v-dialog
                  v-if="form_scale.scale !== ''"
                  v-model="employee_scale_dialog"
                  persistent
                  max-width="1200"
                >
                  <v-card class="pb-4">
                    <v-card-title> Escala de {{ form_scale.employee.full_name }} </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="8" lg="8">
                          <v-container fluid>
                            <v-calendar
                              ref="employee_calendar"
                              v-model="calendar_focus"
                              :type="calendar_type"
                              :events="form_scale.events"
                              :event-color="getEventColor"
                              @change="getIndividualEvents"
                              @click:more="viewDay"
                              @click:date="addDayEmployeeScale"
                            >
                            </v-calendar>
                          </v-container>
                          <v-divider></v-divider>
                          <v-container fluid>
                            Quadro de Horários
                            <v-textarea
                              v-model="form_scale.scale.schedule.schedule"
                              outlined
                              hide-details="auto"
                              :error-messages="form_scale.schedule_erro"
                              @change="checkFormScaleFields()"
                            ></v-textarea>
                          </v-container>
                        </v-col>

                        <v-col cols="12" md="4" lg="4">
                          <v-subheader>Escala</v-subheader>
                          <v-list max-height="400" class="overflow-y-auto">
                            <v-list-item
                              v-for="(date, index) in form_scale.scale.dates"
                              :key="index"
                              class="d-flex justify-center flex-row align-center"
                              outlined
                            >
                              <v-row>
                                <v-col
                                  cols="12"
                                  class="grey--text text--darken-2 align-center d-flex"
                                  style="font-size: 18px"
                                  sm="12"
                                  md="6"
                                  lg="6"
                                >
                                  Dia: {{ formatDate(date.date) }}
                                </v-col>
                                <v-col cols="12" sm="12" md="6" lg="6">
                                  <v-select
                                    ref="type_select"
                                    v-model="date.scale_type_id"
                                    :items="scales_types"
                                    label="Tipo"
                                    item-text="initials"
                                    item-value="id"
                                    dense
                                    outlined
                                    class="pa-0 ma-0"
                                    hide-details="auto"
                                    :error-messages="form_scale.errors[index]"
                                    @change="
                                      getIndividualEvents() ||
                                        checkFormScaleFields() ||
                                        changeEmployeeScale(index)
                                    "
                                  >
                                    <template v-slot:item="{ item }">
                                      {{ item.initials }} - {{ item.name }}
                                    </template>
                                  </v-select>
                                </v-col>
                              </v-row>

                              <v-list-item-action
                                class="pa-0 ma-0 ml-4 d-flex flex-row justify-center align-center"
                              >
                                <v-btn
                                  class="pa-0 ma-0"
                                  icon
                                  color="red lighten-1"
                                  medium
                                  @click="removeEmployeeScaleDate(index)"
                                >
                                  <v-icon medium>mdi-close</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions class="d-flex justify-space-between px-4">
                      <v-btn
                        color="red lighten-1"
                        class="white--text"
                        @click="employee_scale_dialog = false"
                        >Cancelar</v-btn
                      >
                      <v-btn
                        color="green lighten-1"
                        class="white--text"
                        @click="createEmployeeScaleDate"
                        >Finalizar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
              <v-row>
                <v-col>
                  <v-subheader> Lista de funcionarios </v-subheader>
                  <v-list max-height="400" class="overflow-y-auto">
                    <template v-if="scale_exists">
                      {{ scale }}
                      <v-list-item v-for="employee_id in scale.employees" :key="employee_id">
                        <v-list-item-avatar>
                          <img :src="image_host + getEmployeeById(employee_id).profile_image" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          {{ getEmployeeById(employee_id).full_name }}
                        </v-list-item-content>
                        <v-list-item-action class="d-flex flex-row">
                          <v-btn icon>
                            <v-icon color="blue darken-1" @click="editEmployeeScale(employee_id)"
                              >mdi-calendar</v-icon
                            >
                          </v-btn>
                          <v-btn icon @click="removeEmployeeFromScale(employee_id)">
                            <v-icon color="red lighten-1">mdi-close</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" lg="6">
              <v-card-title class="mt-0 pt-0">Legenda</v-card-title>

              <v-card-text class="mt-4">
                <v-row>
                  <v-col>
                    <v-list :items="scales_types">
                      <template v-for="type in scales_types">
                        <v-list-item :key="type.id">
                          <v-avatar>
                            <v-icon :color="type.color"> mdi-square </v-icon>
                          </v-avatar>
                          {{ type.initials }} - {{ type.name }}
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-col>
          </v-row>
          <v-card-actions class="d-flex justify-end">
            <v-btn color="green lighten-1" class="white--text mr-4 mb-4" large @click="finishScale"
              >Finalizar Escala</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import RESOURCES from '@/global/resources'

export default {
  name: 'ScaleForm',
  components: {
    // EmployeeScaleForm,
  },
  data: function () {
    return {
      type_to_label: {
        month: 'Mês',
        day: 'Dia',
      },
      years_list: [],
      calendar_type: 'month',
      calendar_focus: '',
      events: [],
      image_host: RESOURCES.ASSETS_PROFILE_IMAGES(),
      current_month: '',
      current_year: '',
      value: '',
      add_employee_dialog: false,
      employee_scale_dialog: false,
      scale_exists: false,
      scale: '',
      form_scale: {
        employee: '',
        scale: { dates: [], schedule: '' },
        errors: [],
        invalid: true,
        events: [],
        schedule_erro: [],
      },
      form: {
        month: '',
        month_name: '',
        department: '',
        year: '',
      },
    }
  },
  validations: {
    form_scale: {
      scales: {
        $each: {
          type: required,
        },
      },
    },
  },
  computed: {
    ...mapGetters('utils', ['GET_departmentById']),
    ...mapGetters('employees', ['getEmployeeById', 'getEmployeeExceptList']),
    ...mapGetters('coordinator', [
      'getScaleTypeById',
      'getEmployeeScalesById',
      'getActiveScales',
      'getEmployeeScalesByIdScale',
      'getEmployeeScaleByIdAndScale',
    ]),
    ...mapState('auth', ['user']),
    ...mapState('employees', ['employees']),
    ...mapState('utils', ['months_of_the_year', 'departments']),
    ...mapState('coordinator', ['scales_types', 'scales', 'employees_scales']),
    month: {
      get: function () {
        return this.form.month
      },
      set: function (value) {
        this.form.month = value
      },
    },
    employee_list() {
      if (this.scale != '') {
        return this.getEmployeeExceptList(this.scale.employees)
      } else {
        return []
      }
    },
    year() {
      return this.form.year
    },
  },
  watch: {
    getActiveScales() {
      this.existsScale()
    },
    month() {
      this.form.month_name = this.months_of_the_year.find((mth) => mth.id == this.month).name
      const move = this.month - this.current_month
      this.current_month = this.current_month + move
      this.$refs.calendar.move(move)

      this.existsScale()
      this.getGeneralEvents()
    },
    year() {},
    employee_scale_dialog() {
      if (!this.employee_scale_dialog) {
        this.form_scale.employee = ''
        this.form_scale.scale = { dates: [], schedule: '' }
        this.form_scale.events = []
        this.form_scale.errors = []
        this.form_scale.invalid = false
      }
    },
    employees_scales() {
      if (this.form_scale.employee != '') {
        this.form_scale.scale = this.getEmployeeScaleByIdAndScale(
          this.scale.id,
          this.form_scale.employee.id
        )
      }
      // this.form_scale.scale()
      this.getGeneralEvents()
    },
    scales() {
      this.getGeneralEvents()
    },
  },
  mounted: function () {
    this.form.department = this.user.employee_department
    this.current_month = new Date().getMonth() + 1
    this.month = new Date().getMonth() + 1
    this.form.year = new Date().getFullYear()
    this.current_year = this.form.year
    this.existsScale()
    this.getGeneralEvents()
    this.years_list = this.setYearList()
  },
  methods: {
    ...mapActions('coordinator', [
      'ActionStoreScale',
      'ActionCancelScale',
      'ActionStoreEmployeeScale',
      'ActionDeleteEmploeeFromScale',
      'ActionUpdateEmployeeScaleDate',
      'ActionStoreEmployeeScaleDate',
      'ActionDeleteEmployeeScale',
      'ActionDeleteEmployeeScaleDate',
      'ActionUpdateEmployeeSchedule',
      'ActionFinishScale',
      'ActionEditScale',
    ]),
    ...mapActions('ui', ['ActionSetLoading']),
    setYearList() {
      const currentYear = new Date().getFullYear()
      const yearStart = currentYear - 4
      const years = []

      for (let i = 1; i <= 4; i++) {
        years.push(yearStart + i)
      }

      years.push(currentYear)

      return years
    },
    changeYear() {
      if (this.form.year < this.current_year) {
        this.$refs.calendar.move(-12)
      } else if (this.form.year > this.current_year) {
        this.$refs.calendar.move(12)
      }
      this.current_year = this.form.year
      this.existsScale()
      this.getGeneralEvents()
    },
    finishScale() {
      try {
        this.$swal({
          icon: 'warning',
          title: 'Finalizar?',
          text: 'Deseja realmente finalizar essa escala? \nVocê não poderá editar após aceitar!',
          showCancelButton: true,
        }).then(async (result) => {
          if (result.value) {
            await this.ActionFinishScale(this.scale.id)
            this.$swal({
              icon: 'success',
              title: 'Finalizada',
              text: 'Escala finalizar com sucesso',
            })
          }
        })
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }
    },
    getGeneralEvents() {
      const events = []
      if (this.scale_exists) {
        this.getEmployeeScalesByIdScale(this.scale.id).map((scale) => {
          const employee = this.getEmployeeById(scale.employee_id)
          scale.dates.map((date) => {
            if (date.type && date.type == 'RECIPIENT') return
            const scale_type = this.getScaleTypeById(date.scale_type_id)
            events.push({
              name: `${scale_type.initials} - ${employee.full_name}`,
              start: date.date,
              end: date.date,
              color: scale_type.color,
              timed: false,
            })
          })
        })
      }
      this.events = events
    },
    existsScale() {
      this.scale_exists = false
      this.getActiveScales.map((scale) => {
        if (scale.month == this.month && scale.year == this.form.year) {
          this.scale = scale
          this.scale_exists = true
        }
      })
    },
    getEventColor(event) {
      return event.color
    },
    viewDay({ date }) {
      this.calendar_focus = date
      this.calendar_type = 'day'
    },
    setToday() {
      this.focus = ''
      this.current_month = new Date().getMonth() + 1
      this.month = new Date().getMonth() + 1
      this.form.year = new Date().getFullYear()
      this.current_year = this.form.year
    },
    async next() {
      await this.$refs.calendar.next()

      const date = new Date(await this.$refs.calendar.value)
      const month = date.getMonth() + 2

      this.current_month = month > 12 ? month - 12 : month
      this.month = month > 12 ? month - 12 : month
      this.form.year = month > 12 ? date.getFullYear() + 1 : date.getFullYear()
      this.current_year = month > 12 ? date.getFullYear() + 1 : date.getFullYear()
    },
    async prev() {
      await this.$refs.calendar.prev()

      const date = new Date(await this.$refs.calendar.value)

      this.current_month = date.getMonth() + 1
      this.month = date.getMonth() + 1
      this.form.year = this.month > 12 ? date.getFullYear() + 1 : date.getFullYear()
      this.current_year = this.month > 12 ? date.getFullYear() + 1 : date.getFullYear()
    },
    sortEmployeeScaleByDate(dateA, dateB) {
      if (dateA.date < dateB.date) {
        return -1
      }
      if (dateA.date > dateB.date) {
        return 1
      }
      // a deve ser igual a b
      return 0
    },
    async addDayEmployeeScale(data) {
      try {
        this.$refs.calendar.move(0)
        if (data.month == this.month) {
          const new_employee_scale = {
            date: data.date,
            scale_type_id: '',
            employee_scale_id: this.form_scale.scale.id,
          }
          this.form_scale.scale.dates.push(new_employee_scale)
          this.form_scale.errors.push([])
          this.form_scale.scale.dates.sort(this.sortEmployeeScaleByDate)
        }
      } catch (error) {}
    },
    formatDate(date) {
      let dia = date.split('-')[2]
      let mes = date.split('-')[1]
      let ano = date.split('-')[0]
      return ('0' + dia).slice(-2) + '/' + ('0' + mes).slice(-2) + '/' + ano
    },
    async removeEmployeeScaleDate(index) {
      try {
        const date = this.form_scale.scale.dates[index]
        if (date.id) {
          await this.ActionDeleteEmployeeScaleDate(date.id)
        } else {
          this.form_scale.scale.dates.splice(index, 1)
          this.form_scale.errors.splice(index, 1)
        }
        this.getIndividualEvents()
      } catch (error) {}
    },
    getIndividualEvents() {
      const events = []

      this.form_scale.scale.dates.map((date) => {
        if (date.scale_type_id !== '') {
          const scale_type = this.getScaleTypeById(date.scale_type_id)

          events.push({
            name: `${scale_type.initials}`,
            start: date.date,
            end: date.date,
            color: scale_type.color,
            timed: false,
          })
        }
      })

      this.form_scale.events = events
    },
    async dismiss(event) {
      this.$refs.calendar.move(0)
      this.getGeneralEvents()
    },
    async scaleCreate() {
      this.ActionSetLoading(true)
      try {
        const new_scale = {
          month_id: this.form.month,
          cordinator_id: this.user.id,
          department_id: this.user.employee_department,
          year: this.form.year,
          status: 1,
        }
        await this.ActionStoreScale(new_scale)
        this.$swal({
          icon: 'success',
          title: 'Criado',
          text: 'Escala criada com sucesso',
        })
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }
      this.ActionSetLoading(false)
    },
    editScale() {
      try {
        this.$swal({
          icon: 'warning',
          title: 'Atenção!',
          html: '<p>Deseja abrir a escala para edição?</p>',
          showCancelButton: true,
        }).then(async (result) => {
          if (result.value) {
            await this.ActionEditScale(this.scale.id)
            this.$swal({
              icon: 'success',
              title: 'Sucesso',
              text: 'A escala foi aberta para edição.',
            })
          }
        })
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }
    },
    cancelScale() {
      try {
        this.$swal({
          icon: 'warning',
          title: 'Atenção!',
          html:
            '<p style="text-align:justify">Você está preste a excluir uma escala e a mesma não poderá mais ser visualizada.</p><br><p style="text-align:justify">Caso queira corrigir algum dado, clique no botar "Editar Escala".</p><br></bt><p style="text-align:justify">Deseja excluir a escala?</p>',
          showCancelButton: true,
        }).then(async (result) => {
          if (result.value) {
            await this.ActionCancelScale(this.scale.id)
            this.$swal({
              icon: 'success',
              title: 'Cancelada',
              text: 'Escala cancelada com sucesso',
            })
          }
        })
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }
    },
    checkFormScaleFields() {
      this.form_scale.invalid = false

      this.form_scale.scale.dates.map((date, index) => {
        if (date.scale_type_id == '') {
          this.form_scale.errors[index] = ['Selecione uma opção']
          this.form_scale.invalid = true
        } else this.form_scale.errors[index] = []
      })
      if (this.form_scale.scale.schedule.schedule == '') {
        this.form_scale.invalid = true
        this.form_scale.schedule_erro = ['Campo obrigatório']
      } else {
        this.form_scale.schedule_erro = []
      }
    },
    changeEmployeeScale(index) {
      if (this.form_scale.scale.dates[index].id) {
        this.form_scale.scale.dates[index].toUpdate = true
      }
    },
    async createEmployeeScale(employee) {
      try {
        this.form_scale.employee = employee
        await this.ActionStoreEmployeeScale({
          employee_id: employee.id,
          scale_id: this.scale.id,
        })
        this.form_scale.scale = this.getEmployeeScaleByIdAndScale(
          this.scale.id,
          this.form_scale.employee.id
        )
        this.add_employee_dialog = false
        this.employee_scale_dialog = true
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }
      this.ActionSetLoading(false)
    },
    async createEmployeeScaleDate() {
      try {
        this.checkFormScaleFields()
        if (!this.form_scale.invalid) {
          await this.form_scale.scale.dates.map(async (date) => {
            try {
              if (date.toUpdate && date.id) {
                //Caso tenha ID significa que ja foi criada antes e foi alterada
                await this.ActionUpdateEmployeeScaleDate(date)
              } else if (!date.id) {
                await this.ActionStoreEmployeeScaleDate(date)
              }
            } catch (error) {
              throw error
            }
          })
          await this.ActionUpdateEmployeeSchedule(this.form_scale.scale.schedule)
          this.$swal({
            icon: 'success',
            title: 'Criado',
            text: 'O funcionário foi adicionado à escala',
          })
          this.employee_scale_dialog = false
        } else {
          this.$swal({
            icon: 'warning',
            title: 'Atenção',
            text: 'Existem campos vazios',
          })
        }
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }

      this.ActionSetLoading(false)
    },
    async removeEmployeeFromScale(employee_id) {
      this.ActionSetLoading(true)
      try {
        this.$swal({
          icon: 'warning',
          title: 'Remover?',
          text: 'Deseja realmente remover este funcionário da escala?',
          showCancelButton: true,
        }).then(async (result) => {
          if (result.value) {
            await this.ActionDeleteEmploeeFromScale({
              scale_id: this.scale.id,
              employee_id,
            })
            this.$swal({
              icon: 'success',
              title: 'Removido',
              text: 'O funcionário foi removido da escala',
            })
          }
        })
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }
      this.ActionSetLoading(false)
    },
    editEmployeeScale(employee_id) {
      this.form_scale.employee = this.getEmployeeById(employee_id)
      this.form_scale.scale = this.getEmployeeScaleByIdAndScale(this.scale.id, employee_id)
      this.getIndividualEvents()
      this.employee_scale_dialog = true
    },
  },
}
</script>
